import React from 'react';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const OfficeLocation = () => {
    return (
        <div className='md:flex grid grid-cols-1 gap-8 px-4 md:px-12 py-12'>
            <div className='flex-1'>
                <h1 className='text-blue-700 text-4xl text-center md:text-4xl mb-4 font-medium'>Office location</h1>
                <div className='flex items-center'>
                    <FontAwesomeIcon className='text-4xl text-red-600' icon={faLocationDot}></FontAwesomeIcon>
                    <h4 className='text-xl ml-4 font-semibold'>Career Hikers Private Limited, Lehra Bazaar, Rampura Phul, Punjab-151103</h4>
                </div>
                <div className='flex items-center mt-2'>
                    <FontAwesomeIcon className='text-4xl text-blue-400' icon={faEnvelope}></FontAwesomeIcon>
                    <h4 className='text-xl ml-2 font-semibold'><a href="mailto:info@careerhikers.com">info@careerhikers.com</a></h4>
                </div>
                <div className='flex items-center mt-2'>
                    <FontAwesomeIcon className='text-4xl text-blue-400' icon={faPhone}></FontAwesomeIcon>
                    <h4 className='text-xl ml-2 font-semibold'>9958225105</h4>
                </div>
            </div>
            <div className='flex-1'>
                <iframe title='Lehra Bazzar' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3445.8212808211397!2d75.23569811512047!3d30.27067298180053!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3910c485388062b1%3A0x79276bf845e22d84!2sLehra%20Bazaar%2C%20Rampura%20Phul%2C%20Punjab%20151103%2C%20India!5e0!3m2!1sen!2sbd!4v1660114725663!5m2!1sen!2sbd" style={{ border: '0' }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" className='w-full h-72 mt-2'></iframe>
            </div>
        </div>
    );
};

export default OfficeLocation;